import { useState } from 'react';
import { useDropdown } from '../../hooks/useDropdown';
import clsx from 'clsx';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import styles from './TablePickerMenu.module.scss';
import toolbarStyles from '../PlateToolbar/PlateToolbar.module.scss';

interface TablePickerMenuProps {
    onSelect: (rowCount: number, colCount: number) => void;
    maxRows?: number;
    maxCols?: number;
}

export function TablePickerMenu({ onSelect, maxRows = 6, maxCols = 6 }: TablePickerMenuProps) {
    const [hover, setHover] = useState<{ r: number; c: number } | null>(null);
    const { open, setOpen, close, ref: wrapRef } = useDropdown({ onClose: () => setHover(null) });

    return (
        <div className={styles.wrap} ref={wrapRef}>
            <button
                type="button"
                className={clsx(toolbarStyles.btn, open && toolbarStyles.btnActive)}
                onMouseDown={(e) => {
                    e.preventDefault();
                    setOpen((o) => !o);
                }}
                title="Insert table"
                aria-label="Insert table"
                aria-haspopup="true"
                aria-expanded={open}
            >
                <TableChartOutlinedIcon fontSize="small" />
                <ArrowDropDownRoundedIcon className={styles.caret} fontSize="small" aria-hidden />
            </button>
            {open && (
                <div className={styles.popover} role="dialog" aria-label="Pick table size" onMouseLeave={() => setHover(null)}>
                    <div className={styles.grid}>
                        {Array.from({ length: maxRows }).map((_, r) => (
                            <div key={r} className={styles.row}>
                                {Array.from({ length: maxCols }).map((_, c) => {
                                    const active = hover ? r <= hover.r && c <= hover.c : false;
                                    return (
                                        <button
                                            key={c}
                                            type="button"
                                            className={clsx(styles.cell, active && styles.cellActive)}
                                            onMouseEnter={() => setHover({ r, c })}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                onSelect(r + 1, c + 1);
                                                close();
                                            }}
                                            aria-label={`Insert ${r + 1} by ${c + 1} table`}
                                        />
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                    <div className={styles.label}>{hover ? `${hover.r + 1} × ${hover.c + 1}` : 'Pick a size'}</div>
                </div>
            )}
        </div>
    );
}
